'use strict';

function PerformanceReviewAgreementSummaryController(performanceReviewService, $location, $route, $q, $modal) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.stepChange = stepChange;
  vm.questionIsComplete = questionIsComplete;
  vm.questionnaireSetLock = questionnaireSetLock;
  vm.questionnaireIsLockable = questionnaireIsLockable;
  vm.questionnaireIsCompletedByBoth = questionnaireIsCompletedByBoth;
  vm.questionnaireApprove = questionnaireApprove;
  vm.questionnaireDeny = questionnaireDeny;
  vm._agreementResponseOk = _agreementResponseOk;
  vm.hasRole = _hasRole;

  vm.claimFirstTurn = claimFirstTurn;
  vm.isFirstTurn = isFirstTurn;

  vm.openQuestionnaireApproveModal = openQuestionnaireApproveModal;

  function $onInit() {
    vm.max = vm.data.max;
    vm.summary = vm.data.questions || [];
    vm.answers = vm.data.questions.map(function answer(question) {
      return question.answer;
    });
    vm.completed = vm.data.completed;
    vm.manager_completed = vm.data.manager_completed;
    vm.coworker_completed = vm.data.coworker_completed;
    vm.user = vm.data.user || {};
    vm.submitting = false;
    vm.round = vm.data.round;
    vm.turn = vm.data.turn;
    vm.token = vm.data.token;
  }

  function questionIsComplete(question) {
    return question.answer.state === 'COMPLETE';
  }

  function questionnaireSetLock() {
    vm.submitting = true;

    return performanceReviewService.update.agreement.summary(vm.data.token, true)
      .then(_agreementResponseOk);
  }

  function openQuestionnaireApproveModal() {
    vm.questionnaireApproveModal = $modal({
      template: require('./performance-review-agreement-summary-confirm.modal.html'),
      show: true
    });
    vm.questionnaireApproveModal.$scope.submit = questionnaireApprove;
  }

  function questionnaireApprove() {
    vm.submitting = true;
    return performanceReviewService.update.agreement.summary(vm.data.token, true).then(_agreementResponseOk);
  }

  function questionnaireDeny() {
    vm.submitting = true;
    return performanceReviewService.update.agreement.summary(vm.data.token, false).then(_agreementResponseOk);
  }

  function questionnaireIsLockable() {
    return vm.summary.every(vm.questionIsComplete);
  }

  function questionnaireIsCompletedByBoth() {
    return !vm.completed && vm.manager_completed && vm.coworker_completed;
  }

  function stepChange(to) {
    $location.path(performanceReviewService.urls.agreement.questionnaire.step({token: vm.data.token, step: to}));
    return $q.resolve();
  }

  function _agreementResponseOk(response) {
    vm.completed = response.data.completed;
    vm.manager_completed = response.data.manager_completed;
    vm.coworker_completed = response.data.coworker_completed;
    vm.turn = response.data.turn;
    vm.submitting = false;
    vm.questionnaireApproveModal.$scope.$hide();
  }

  function _hasRole(role) {
    return vm.me.groups
      .map(function (group) {
        return group.name;
      })
      .some(function (groupName) {
        return groupName === role;
      });
  }

  function claimFirstTurn() {
    return function (promise) {
      return promise.finally(function () {
        $location.path(performanceReviewService.urls.agreement.questionnaire.step({token: vm.data.token, step: 1}));
      });
    };
  }

  function isFirstTurn() {
    // Make sure to match claim_for_turn
    return vm.turn.user === null && vm.completed === false && vm.manager_completed === false &&
      vm.coworker_completed === false;
  }
}

module.exports = PerformanceReviewAgreementSummaryController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-summary/performance-review-agreement-summary.controller.js
 ** module id = 302
 ** module chunks = 0
 **/